import { Injectable, NgModule, defineInjectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigManagerService, ConfigManagerModule, CONFIG_MANAGER_SERVICE_CONFIGURATION } from '@xpo-ltl/config-manager';
import { ApiRequest, DataApiService, NotificationService } from '@xpo-ltl/data-api';
import { ConditioningService } from '@xpo-ltl/common-services';
import { result } from 'lodash';
import { switchMap, take, tap } from 'rxjs/operators';
import { of, Subject } from 'rxjs';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@xpo-ltl/data-api';
import * as ɵngcc3 from '@xpo-ltl/config-manager';
import * as ɵngcc4 from '@xpo-ltl/common-services';
class DmsDocumentResp {
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DmsDocumentRqst {
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const DocType = {
    BillOfLading: 'BL',
    DeliveryReceipt: 'DR',
    DeliveryReturnReceipt: 'DRRR',
    CustomsDocuments: 'CUST',
    InspectionReport: 'IR',
    LetterOfAuthority: 'LOA',
    NmfcClassInspectionCertificate: 'NCIC',
    WeightInspectionCertificate: 'WI',
    WeightAndResearchPhotos: 'WRFO',
    InvoicePdf: 'ARIN',
    ClaimsAttachment: 'CLAT',
    CustomerUpload: 'CUPD',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class DocTypeHelperClass {
    constructor() {
        this._values = [];
        this._keys = [];
        // noinspection TsLint
        for (const /** @type {?} */ obj in DocType) {
            this._values.push(DocType[obj]);
            this._keys.push(obj);
        }
    }
    /**
     * @return {?}
     */
    values() {
        return this._values;
    }
    /**
     * @return {?}
     */
    keys() {
        return this._keys;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    toEnum(value) {
        for (const /** @type {?} */ obj in DocType) {
            if (DocType[obj] === value) {
                return /** @type {?} */ (DocType[obj]);
            }
        }
    }
}
const /** @type {?} */ DocTypeHelper = new DocTypeHelperClass();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ImageFormat = {
    PDF: 'pdf',
    JPG: 'jpg',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ConfigManagerProperties = {
    Region: 'region',
    DmsApiEndpoint: 'dmsApiEndpoint',
    ImagingApiEndpoint: 'imagingApiEndpoint',
    ImageCorpCode: 'imageCorpCode',
    ApiUrl: 'apiUrl',
};
class DmsService {
    /**
     * @param {?} http
     * @param {?} dataManager
     * @param {?} config
     * @param {?} conditioningService
     * @param {?} notificationService
     */
    constructor(http, dataManager, config, conditioningService, notificationService) {
        this.http = http;
        this.dataManager = dataManager;
        this.config = config;
        this.conditioningService = conditioningService;
        this.notificationService = notificationService;
        this.dmsApiEndpoint = config.getSetting(ConfigManagerProperties.DmsApiEndpoint);
        this.imagingApiEndpoint = config.getSetting(ConfigManagerProperties.ImagingApiEndpoint);
        this.corpCode = config.getSetting(ConfigManagerProperties.ImageCorpCode);
        this.apiUrl = config.getSetting(ConfigManagerProperties.ApiUrl);
    }
    /**
     * @param {?=} url
     * @return {?}
     */
    generateFullyQualifiedUrl(url = '') {
        return this.appendUrlParts(this.apiUrl, url);
    }
    /**
     * @param {?} part1
     * @param {?} part2
     * @return {?}
     */
    appendUrlParts(part1, part2) {
        const /** @type {?} */ conditionedPart1 = `${part1}${part1.endsWith('/') ? '' : '/'}`;
        const /** @type {?} */ conditionedPart2 = `${part2.startsWith('/') ? part2.substring(1) : part2}`;
        return `${conditionedPart1}${conditionedPart2}`;
    }
    /**
     * @return {?}
     */
    authenticateDms() {
        const /** @type {?} */ requestUri = `${this.dmsApiEndpoint}/oauth/dmstoken`;
        const /** @type {?} */ request = new ApiRequest(requestUri);
        if (this.dmsAccessToken && !this.isAuthTokenExpired()) {
            return of(this.dmsAccessToken);
        }
        return this.dataManager.post(request).pipe(tap(response => {
            this.dmsAccessToken = /** @type {?} */ (response);
            this.dmsAccessToken.expiresAt = new Date(Date.now() + (this.dmsAccessToken.expires_in * 1000));
        }));
    }
    /**
     * @return {?}
     */
    isAuthTokenExpired() {
        return new Date() > this.dmsAccessToken.expiresAt;
    }
    /**
     * @param {?} documentRequest
     * @return {?}
     */
    getDmsDocument2(documentRequest) {
        return this.authenticateDms()
            .pipe(take(1), switchMap((token) => {
            const /** @type {?} */ requestUri = this.generateFullyQualifiedUrl(this.appendUrlParts(this.dmsApiEndpoint, `document/${this.corpCode}/${documentRequest.docType}/${documentRequest.referenceNbr}`));
            return this.http.get(requestUri, { responseType: 'arraybuffer', headers: { DMSAuth: token.access_token } });
        }));
    }
    /**
     * @param {?} documentRequest
     * @return {?}
     */
    getDmsDocument(documentRequest) {
        const /** @type {?} */ mySubject = new Subject();
        if (documentRequest.docType === DocType.InvoicePdf) {
            this.getDmsDocument2(documentRequest).pipe(take(1)).subscribe(success => {
                mySubject.next(success);
            }, error => {
                if (result(error, 'error.errorCode', undefined)) {
                    mySubject.error(`${result(error, 'error.message', '')}`);
                }
                else {
                    mySubject.error('No data found');
                }
            });
        }
        else {
            let /** @type {?} */ httpHeaders = new HttpHeaders();
            httpHeaders = httpHeaders.append('Content-Type', 'multipart/form-data');
            const /** @type {?} */ url = this.appendUrlParts(this.imagingApiEndpoint, `shipments/${this.conditioningService.conditionProNumber(documentRequest.proNbr, 11)}/imaged-docs?imageFormat=${documentRequest.imageFormat}&imageType=${documentRequest.docType}&multiPartResp=true`);
            const /** @type {?} */ apiRequest = new ApiRequest(url);
            // apiRequest.httpOptions = {observe: 'response', responseType: 'arraybuffer', headers: httpHeaders};
            apiRequest.httpOptions = { responseType: 'arraybuffer', headers: httpHeaders };
            apiRequest.dataOptions = ApiRequest.concealedCall;
            this.dataManager.get(apiRequest).subscribe((response) => {
                const /** @type {?} */ body = /** @type {?} */ (response.body);
                const /** @type {?} */ responseContentType = response.headers.get('Content-Type');
                const /** @type {?} */ boundary = /** @type {?} */ (responseContentType.split(';')[1].split('=')[1]);
                const /** @type {?} */ bodyString = String.fromCharCode.apply(null, new Uint8Array(body));
                mySubject.next(body.slice(bodyString.indexOf('%PDF'), bodyString.lastIndexOf(boundary)));
                mySubject.complete();
            }, error => {
                mySubject.error(`${result(error, 'error.message', '')}`);
            });
        }
        return mySubject.asObservable();
    }
}
DmsService.ɵfac = function DmsService_Factory(t) { return new (t || DmsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.DataApiService), ɵngcc0.ɵɵinject(ɵngcc3.ConfigManagerService), ɵngcc0.ɵɵinject(ɵngcc4.ConditioningService), ɵngcc0.ɵɵinject(ɵngcc2.NotificationService)); };
DmsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DmsService, factory: DmsService.ɵfac, providedIn: 'root' });
/** @nocollapse */
DmsService.ctorParameters = () => [
    { type: HttpClient },
    { type: DataApiService },
    { type: ConfigManagerService },
    { type: ConditioningService },
    { type: NotificationService }
];
/** @nocollapse */ DmsService.ngInjectableDef = defineInjectable({ factory: function DmsService_Factory() { return new DmsService(inject(HttpClient), inject(DataApiService), inject(ConfigManagerService), inject(ConditioningService), inject(NotificationService)); }, token: DmsService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DmsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.DataApiService }, { type: ɵngcc3.ConfigManagerService }, { type: ɵngcc4.ConditioningService }, { type: ɵngcc2.NotificationService }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const ɵ0 = { configFileUrl: './assets/config.json' };
class SdkDmsModule {
}
SdkDmsModule.ɵfac = function SdkDmsModule_Factory(t) { return new (t || SdkDmsModule)(); };
SdkDmsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SdkDmsModule });
SdkDmsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
    ], imports: [[
            ConfigManagerModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SdkDmsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ConfigManagerModule
                ],
                providers: [
                    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SdkDmsModule, { imports: function () { return [ConfigManagerModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { DocTypeHelper, DmsDocumentResp, DmsDocumentRqst, DocType, ImageFormat, DmsService, SdkDmsModule };

